import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { UseQueriesProps } from "@lib/types/General";
import {
  apiAddManualTransaction,
  apiDeleteManualTransaction,
  apiGetManualTransactions,
  apiUpdateManualTransaction,
} from "@lib/api/transaction";

export const useCashPaymentQueries = (props: UseQueriesProps) => {
  const { queryKey, params, id, messages, enabled = true } = props;
  const queryKeys = queryKey || [
    "cash-payment",
    params ? JSON.stringify(params) : id,
  ];
  const queryClient = useQueryClient();

  const cashPaymentsQuery = useQuery({
    queryFn: () => apiGetManualTransactions(params),
    queryKey: queryKeys,
    enabled: !!params && !!enabled,
  });

  const addCashPaymentMutation = useMutation({
    mutationFn: apiAddManualTransaction,
    mutationKey: ["cash-payment"],
    onSuccess() {
      toast.success(
        (messages["common.createdMessage"] as string).replace(
          "{name}",
          messages["common.cashPayments"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  const deleteCashPaymentMutation = useMutation({
    mutationFn: apiDeleteManualTransaction,
    mutationKey: ["cash-payment"],
    onSuccess() {
      toast.success(
        (messages["common.deletedMessage"] as string).replace(
          "{name}",
          messages["common.cashPayments"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  const updateCashPaymentMutation = useMutation({
    mutationFn: apiUpdateManualTransaction,
    mutationKey: ["cash-payment"],
    onSuccess() {
      toast.success(
        (messages["common.updatedMessage"] as string).replace(
          "{name}",
          messages["common.cashPayments"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  return {
    cashPaymentsQuery,
    addCashPaymentMutation,
    deleteCashPaymentMutation,
    updateCashPaymentMutation,
  };
};
